<div class="video-dialog">
  <iframe [src]="safeResourceUrl"
          allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0"
          height="450"
          mozallowfullscreen webkitallowfullscreen width="800"></iframe>
</div>
